import VueRouter from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from '../store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';
import { buildPermissionsFromRouter } from '../helper/permissionsHelper';

const routes = [...dashboard.routes];

export const router = new VueRouter({ mode: 'history', routes });
export const routesWithPermissions = buildPermissionsFromRouter(routes);

export const validateAuthenticateRoutePermission = (to, next, { getters }) => {
  const { isLoggedIn, getCurrentUser: user } = getters;

  if (!isLoggedIn) {
    window.location = '/app/login';
    return '/app/login';
  }

  // Block access for unconfirmed users to any dashboard route
  // Allow navigation to the verify email page and confirmation page only
  const isUnconfirmed = user && user.confirmed === false;
  const isVerifyEmailPath =
    to && to.path && to.path.includes('/app/auth/verify-email');
  const isConfirmationPath =
    to && to.path && to.path.includes('/app/auth/confirmation');
  if (isUnconfirmed && !isVerifyEmailPath && !isConfirmationPath) {
    window.location = frontendURL('auth/verify-email');
    return frontendURL('auth/verify-email');
  }

  // Check if subscription or trial is expired
  const accountId = to.params.accountId || to.params.account_id;
  if (accountId) {
    const account = getters['accounts/getAccount'](parseInt(accountId, 10));
    if (account) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      let isExpired = false;
      // Match Dashboard.vue: free plans are not gated by trial/subscription expiry.
      if (account.plan?.free !== true) {
        if (account.trial_period_ends) {
          const trialEndDate = new Date(account.trial_period_ends);
          trialEndDate.setHours(0, 0, 0, 0);
          if (trialEndDate < today) {
            isExpired = true;
          }
        }
        if (account.subscription?.current_period_end) {
          const subscriptionEndDate = new Date(
            account.subscription.current_period_end
          );
          subscriptionEndDate.setHours(0, 0, 0, 0);
          if (subscriptionEndDate < today) {
            isExpired = true;
          }
        }
      }

      if (isExpired) {
        // Allow only billing routes
        const isBillingRoute =
          to.name === 'billing_settings_index' ||
          to.name === 'settings_billing_add_credits' ||
          to.name === 'settings_billing_checkout' ||
          (to.path && to.path.includes('/settings/billing'));

        if (!isBillingRoute) {
          // Redirect to dashboard (which will show the modal)
          return next(frontendURL(`accounts/${accountId}/dashboard`));
        }
      }
    }
  }

  if (!to.name) {
    return next(frontendURL(`accounts/${user.account_id}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
